module.exports = __webpack_public_path__ + "assets/file-operate.6079b4306fa88d081cc46d1997b652fe.png";